<div class="ui basic segment" [class.loading]="isLoading">
    <app-steps
        #appSteps
        [steps]="[detailsStep, metricsStep, participantsStep, summaryStep]"
        action="Create"
        (onPrimary)="onSave()"
        (onNext)="onNextStep($event)"
        (onPrevious)="onPreviousStep($event)"
    >
        <app-step
            #detailsStep
            [stepForm]="detailsForm"
            step="performance.goal-store.detailsStepMenuLabel"
            title="performance.goal-store.detailsStepTitle"
        >
            <app-form-goal-details #detailsForm [goal]="goal"></app-form-goal-details>
        </app-step>

        <app-step
            #metricsStep
            [stepForm]="metricsForm"
            step="performance.goal-store.metricsStepMenuLabel"
            title="performance.goal-store.metricsStepTitle"
        >
            <app-form-goal-metrics #metricsForm [goal]="goal"></app-form-goal-metrics>
        </app-step>

        <app-step
            #participantsStep
            [stepForm]="participantsForm"
            step="performance.goal-store.participantsStepMenuLabel"
            title="performance.goal-store.participantsStepTitle"
        >
            <app-form-goal-participants
                #participantsForm
                [goal]="goal"
                [participants]="participants"
            ></app-form-goal-participants>
        </app-step>

        <app-step
            #summaryStep
            [stepForm]="summaryForm"
            step="performance.goal-store.summaryStepMenuLabel"
            title="performance.goal-store.summaryStepTitle"
        >
            <app-form-goal-summary #summaryForm [goal]="goal" [participants]="participants"></app-form-goal-summary>
        </app-step>
    </app-steps>
</div>
